function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define("YWWriterIconsReact.EyeSlashFill", ["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.React);
    global.YWWriterIconsReact = global.YWWriterIconsReact || {};
    global.YWWriterIconsReact["EyeSlashFill"] = mod.exports.default;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (exports, React) {
  "use strict";

  var EyeSlashFill = props => /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.005 6.5001C14.765 6.5001 17.005 8.7401 17.005 11.5001C17.005 12.1501 16.875 12.7601 16.645 13.3301L19.565 16.2501C20.9261 15.1144 22.0272 13.678 22.7657 12.0436C22.9218 11.6981 22.9215 11.3021 22.765 10.9567C20.907 6.85568 16.7861 4.0001 11.995 4.0001C10.595 4.0001 9.255 4.2501 8.015 4.7001L10.175 6.8601C10.745 6.6301 11.355 6.5001 12.005 6.5001ZM2.64 3.1351C2.2893 3.4858 2.2893 4.0544 2.64 4.4051L4.745 6.5101C3.239 7.68042 2.0293 9.20467 1.23538 10.9559C1.07856 11.3018 1.07867 11.6985 1.23544 12.0445C3.09371 16.145 7.21427 19.0001 12.005 19.0001C13.555 19.0001 15.035 18.7001 16.385 18.1601L16.805 18.5801L19.0995 20.8667C19.4506 21.2167 20.0189 21.2162 20.3695 20.8656C20.7205 20.5146 20.7205 19.9456 20.3695 19.5946L3.91 3.1351C3.5593 2.78439 2.9907 2.7844 2.64 3.1351ZM7.535 9.3001L9.085 10.8501C9.035 11.0601 9.005 11.2801 9.005 11.5001C9.005 13.1601 10.345 14.5001 12.005 14.5001C12.225 14.5001 12.445 14.4701 12.655 14.4201L14.205 15.9701C13.535 16.3001 12.795 16.5001 12.005 16.5001C9.245 16.5001 7.005 14.2601 7.005 11.5001C7.005 10.7101 7.205 9.9701 7.535 9.3001ZM11.845 8.5201L14.995 11.6701L15.015 11.5101C15.015 9.8501 13.675 8.5101 12.015 8.5101L11.845 8.5201Z",
    fill: "currentColor"
  }));
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports.default = EyeSlashFill;
});